"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _svgs = require("../../svgs");

var _ArtsyLogoBlackIcon = require("../../svgs/ArtsyLogoBlackIcon");

var _usePrevious = require("../../utils/usePrevious");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Spacer = require("../Spacer");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    max-height: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    max-height: 100vh;\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AnimatedView = (0, _reactSpring.animated)(_Box.Box);
/**
 * Modal.
 * Spec: https://app.zeplin.io/project/5acd19ff49a1429169c3128b/screen/5c75ad115c1db5628cc03c2a
 */

var Modal = function Modal(_ref) {
  var children = _ref.children,
      refreshModalContentKey = _ref.refreshModalContentKey,
      FixedButton = _ref.FixedButton,
      title = _ref.title,
      show = _ref.show,
      isWide = _ref.isWide,
      hasLogo = _ref.hasLogo,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)({
    opacity: 1,
    onRest: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      springContentAnimation = _useState2[0],
      setSpringContentAnimation = _useState2[1];

  var _useState3 = (0, _react.useState)({
    transform: "translate(-50%, 0%) translateY(50vh)",
    opacity: 0,
    onRest: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      springModalAnimation = _useState4[0],
      setSpringModalAnimation = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      visibleContent = _useState6[0],
      setVisibleContent = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      renderModal = _useState8[0],
      setRenderModal = _useState8[1];

  var previousChangeKey = (0, _usePrevious.usePrevious)(refreshModalContentKey);
  var contentAnimation = (0, _reactSpring.useSpring)(springContentAnimation);
  var modalAnimation = (0, _reactSpring.useSpring)(springModalAnimation);

  var handleEscapeKey = function handleEscapeKey(event) {
    if (event && event.key === "Escape") {
      onClose();
    }
  };

  (0, _react.useEffect)(function () {
    if (previousChangeKey === refreshModalContentKey) {
      setVisibleContent(ModalContent);
    } else {
      // Fades out content if changeKey updates
      setSpringContentAnimation({
        opacity: 0,
        onRest: function onRest() {
          return fadeInNewContent();
        }
      });
    }
  }, [children]);
  (0, _react.useEffect)(function () {
    if (show) {
      setRenderModal(true); // Binds key event for escape to close modal

      document.addEventListener("keyup", handleEscapeKey, true); // Fixes the body to disable scroll

      document.body.style.overflowY = "hidden";
      setVisibleContent(ModalContent);
      setSpringModalAnimation({
        transform: "translate(-50%, -50%) translateY(0vh)",
        opacity: 1,
        onRest: null
      });
    } else {
      document.body.style.overflowY = "visible";
      document.removeEventListener("keyup", handleEscapeKey, true);
      setSpringModalAnimation({
        transform: "translate(-50%, -50%) translateY(0vh)",
        opacity: 0,
        onRest: function onRest() {
          setSpringModalAnimation({
            transform: "translate(-50%, 0%) translateY(50vh)",
            onRest: null,
            opacity: 0
          });
          onClose();
          setRenderModal(false);
        }
      });
    }
  }, [show]);

  var fadeInNewContent = function fadeInNewContent() {
    // Replaces content
    setVisibleContent(ModalContent); // Fades in new content

    setSpringContentAnimation({
      opacity: 1,
      onRest: null
    });
  };

  var ModalContent = function ModalContent() {
    return _react.default.createElement(AnimatedView, {
      style: contentAnimation
    }, _react.default.createElement(ModalScrollContent, {
      px: 4,
      pt: 2,
      FixedButton: FixedButton
    }, hasLogo && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Flex.Flex, {
      justifyContent: "center"
    }, _react.default.createElement(Logo, null)), _react.default.createElement(_Spacer.Spacer, {
      mb: 1
    })), title && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Flex.Flex, {
      justifyContent: "center"
    }, _react.default.createElement(_Typography.Serif, {
      size: "5t",
      textAlign: "center",
      color: "black100"
    }, title)), _react.default.createElement(_Spacer.Spacer, {
      mb: 1
    })), children), FixedButton && _react.default.createElement(FixedButtonWrapper, {
      px: 4,
      pt: 2,
      pb: 3
    }, FixedButton));
  };

  return _react.default.createElement(_react.default.Fragment, null, renderModal && _react.default.createElement(ModalOuterWrapper, {
    show: show
  }, _react.default.createElement(ModalWrapper, null, _react.default.createElement(ModalElement, {
    style: modalAnimation,
    isWide: isWide,
    show: show
  }, _react.default.createElement(CloseIconWrapper, {
    onClick: function onClick() {
      return onClose();
    }
  }, _react.default.createElement(_svgs.CloseIcon, {
    fill: "black60"
  })), visibleContent))));
};

exports.Modal = Modal;
var FixedButtonWrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__FixedButtonWrapper",
  componentId: "qjtwq0-0"
})(["position:relative;bottom:0;left:0;width:100%;background-color:", ";border-top:1px solid ", ";"], (0, _helpers.color)("white100"), (0, _helpers.color)("black10"));
var ModalOuterWrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__ModalOuterWrapper",
  componentId: "qjtwq0-1"
})(["position:fixed;top:0;left:0;z-index:9999;width:100vw;height:100vh;background-color:rgba(229,229,229,0.5);transition:opacity 250ms ease;opacity:", ";pointer-events:", ";"], function (props) {
  return props.show ? "1" : "0";
}, function (props) {
  return props.show ? "auto" : "none";
});
var ModalWrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "qjtwq0-2"
})(["position:relative;width:100%;height:100%;overflow:hidden;"]);
var ModalElement = (0, _styledComponents.default)(AnimatedView).withConfig({
  displayName: "Modal__ModalElement",
  componentId: "qjtwq0-3"
})(["position:absolute;border-radius:5px;top:50%;left:50%;height:", ";max-height:calc(100vh - 80px);min-height:58px;overflow:hidden;background-color:", ";box-shadow:0px 4px 15px rgba(0,0,0,0.15);width:", ";", ";"], function (props) {
  return props.height ? props.height : "auto";
}, (0, _helpers.color)("white100"), function (props) {
  return props.isWide ? "900px" : "440px";
}, _helpers.media.xs(_templateObject()));
var ModalScrollContent = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__ModalScrollContent",
  componentId: "qjtwq0-4"
})(["height:100%;width:100%;overflow:auto;padding-bottom:", "px;max-height:", ";", ";"], (0, _helpers.space)(2), function (props) {
  return !!props.FixedButton ? "calc(100vh - (80px + ".concat((0, _helpers.space)(9), "px));") : "calc(100vh - 80px)";
}, _helpers.media.xs(_templateObject2(), function (props) {
  return !!props.FixedButton ? "calc(100vh - (80px ".concat((0, _helpers.space)(9), "px));") : "100vh";
}));
var CloseIconWrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Modal__CloseIconWrapper",
  componentId: "qjtwq0-5"
})(["position:fixed;top:", "px;right:", "px;cursor:pointer;"], (0, _helpers.space)(2), (0, _helpers.space)(2));
var Logo = (0, _styledComponents.default)(_ArtsyLogoBlackIcon.ArtsyLogoBlackIcon).withConfig({
  displayName: "Modal__Logo",
  componentId: "qjtwq0-6"
})(["width:100px;"]);
Modal.displayName = "Modal";
//# sourceMappingURL=Modal.js.map